export default "__VITE_ASSET__Bhg_gA1J__"